import { GetCookie, SetCookie } from '@/data/protocols/cache'
import Cookies from 'universal-cookie'

export class UniversalCookieAdapter implements SetCookie, GetCookie {
  constructor (private readonly universalCookies: Cookies) { }
  set (key: string, value: any): void {
    if (value) {
      this.universalCookies.set(key, value, { path: '/' })
    } else {
      this.universalCookies.remove(key, { path: '/' })
    }
  }

  get (key: string): any {
    return this.universalCookies.get(key)
  }
}
